document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.footer__toggle').forEach((toggle) => {
    toggle.addEventListener('click', () => {
      toggle.classList.toggle('expanded');
      const submenu = toggle.nextElementSibling;
      const isExpanded = toggle.getAttribute('aria-expanded') === 'true';

      toggle.setAttribute('aria-expanded', !isExpanded);
      submenu.classList.toggle('active');
    });
  });
});
